module.exports = __webpack_public_path__ + "static/media/garbage-icon-12.7f2fc39a.png";